// extracted by mini-css-extract-plugin
export var actions = "_bv-g";
export var benefitCard = "_bv-b";
export var benefitIcon = "_bv-d";
export var benefitLabel = "_bv-f";
export var benefits = "_bv-a";
export var benefitsSection = "_bv-8";
export var bodyText = "_bv-7";
export var closeButton = "_bv-2";
export var content = "_bv-3";
export var eyebrow = "_bv-4";
export var heading = "_bv-5";
export var image = "_bv-i";
export var imagePanel = "_bv-h";
export var modal = "_bv-0";
export var offerCard = "_bv-c";
export var offerIcon = "_bv-e";
export var sectionLabel = "_bv-9";
export var shell = "_bv-1";
export var title = "_bv-6";